import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { CancelIcon } from '@deliveryhero/armor-icons';
import { useComponentTheme } from '../../utils/hooks';
import { useDialogClassNames } from './hooks/useDialogClassNames';
import { DialogAlignmentContainer, DialogRoot, DialogWindow, DialogCloseButton, DialogContent } from './style';
import { Overlay } from '../Overlay';
import { DIALOG_CLASS_PREFIX, DIALOG_SCROLL_DIALOG, DIALOG_SCROLL_DOCUMENT } from './constants';
import { useDialog } from './hooks/useDialog';
import { PortalToBody } from '../../system/util/PortalToBody';
export var Dialog = forwardRef(function Dialog(_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "children"]);

  var theme = useComponentTheme(DIALOG_CLASS_PREFIX);
  var classNames = useDialogClassNames(DIALOG_CLASS_PREFIX, className);

  var _useDialog = useDialog(props, ref),
      portalProps = _useDialog.portalProps,
      rootProps = _useDialog.rootProps,
      overlayProps = _useDialog.overlayProps,
      alignmentContainerProps = _useDialog.alignmentContainerProps,
      windowProps = _useDialog.windowProps,
      getCloseButtonProps = _useDialog.getCloseButtonProps,
      contentProps = _useDialog.contentProps,
      enableCloseButton = _useDialog.enableCloseButton,
      enableOverlay = _useDialog.enableOverlay;

  return React.createElement(PortalToBody, Object.assign({}, portalProps), React.createElement(DialogRoot, Object.assign({}, rootProps, {
    theme: theme,
    className: classNames.Root
  }), enableOverlay && React.createElement(Overlay, Object.assign({}, overlayProps, {
    className: classNames.Overlay
  })), React.createElement(DialogAlignmentContainer, Object.assign({}, alignmentContainerProps, {
    theme: theme,
    className: classNames.AlignmentContainer
  }), React.createElement(DialogWindow, Object.assign({}, windowProps, {
    theme: theme,
    className: classNames.Window
  }), enableCloseButton && React.createElement(DialogCloseButton, Object.assign({}, getCloseButtonProps(), {
    theme: theme,
    className: classNames.CloseButton
  }), React.createElement(CancelIcon, null)), React.createElement(DialogContent, Object.assign({}, contentProps, {
    theme: theme,
    className: classNames.Content
  }), children)))));
});
Dialog.defaultProps = {
  disableOverlay: false,
  disableEffects: false,
  disableCloseButton: false,
  disableCloseByEscape: false,
  scroll: DIALOG_SCROLL_DIALOG
};